var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kf-button',{staticClass:"go-to-top-button",class:[{ 'go-to-top-button--show': _vm.showButton }],on:{"click":function($event){return _vm.scrollToTop()}}},[_c('ArrowGoToTop',{staticClass:"go-to-top-button__icon icon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }